import PawModel from './PawModel';

class Group extends PawModel {
  static apiType = 'groups';

  static d3Compatible = true;

  name!: string;

  superscope!: string;

  family_ids!: string[];

  user_id!: string;

  read_level!: string;

  static filters: {
    id?: string;
    created_at?: string;
    updated_at?: string;
    name?: undefined | string;
    weight?: undefined | string;
  } = {
    id: '',
    created_at: '',
    updated_at: '',
    name: '',
    weight: '',
  }
}
export default Group;